"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-f18829ae"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = {
    key: 0,
    class: "loading loading-2x"
};
const _hoisted_2 = { class: "settings-card-container accordion settings-accordion" };
const _hoisted_3 = { class: "settings-title-wrapper accordion-header c-hand" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right" }, null, -1 /* HOISTED */));
const _hoisted_5 = { class: "page-title-text" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "accordion-body" };
const _hoisted_8 = { class: "settings-item" };
const _hoisted_9 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "シフト表", -1 /* HOISTED */));
const _hoisted_11 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "全スタッフに「シフト管理」の閲覧権限を付与する。")
], -1 /* HOISTED */));
const _hoisted_13 = { class: "settings-input oplus-form-switch" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_15 = {
    key: 0,
    class: "settings-item"
};
const _hoisted_16 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "プロフィール画像", -1 /* HOISTED */));
const _hoisted_18 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "プロフィール画像を利用する")
], -1 /* HOISTED */));
const _hoisted_20 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_22 = {
    key: 1,
    class: "settings-item"
};
const _hoisted_23 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "労務の閲覧・編集権限", -1 /* HOISTED */));
const _hoisted_25 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト編集者に交通費・労務費・人件費の閲覧権限、時給の編集権限を付与する")
], -1 /* HOISTED */));
const _hoisted_27 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_29 = {
    key: 2,
    class: "settings-item"
};
const _hoisted_30 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "確定", -1 /* HOISTED */));
const _hoisted_32 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "確定前のシフトに枠線を使用する")
], -1 /* HOISTED */));
const _hoisted_34 = { class: "settings-input oplus-form-switch" };
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_36 = { class: "settings-item" };
const _hoisted_37 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "日跨ぎ設定", -1 /* HOISTED */));
const _hoisted_39 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_40 = /*#__PURE__*/ (0, vue_2.createStaticVNode)("<div class=\"tooltip-wrapper\" data-v-f18829ae><span class=\"tooltip-text\" data-v-f18829ae>日を跨ぐシフトを2日に分ける。 <div class=\"split-slot-settings-sample\" data-v-f18829ae><table class=\"split-table\" data-v-f18829ae><thead data-v-f18829ae><tr data-v-f18829ae><th class=\"split-table-header\" data-v-f18829ae>1月1日</th></tr></thead><tbody class=\"split-table-body\" data-v-f18829ae><tr data-v-f18829ae><td data-v-f18829ae><div class=\"split-slot-chip\" data-v-f18829ae><span data-v-f18829ae>レジ</span><span data-v-f18829ae>20:00 ~ 5:00</span></div></td></tr></tbody></table><!-- Arrow here --><i class=\"zmdi zmdi-arrow-right zmdi-hc-lg\" data-v-f18829ae></i><table class=\"split-table\" data-v-f18829ae><thead data-v-f18829ae><tr data-v-f18829ae><th class=\"split-table-header\" data-v-f18829ae>1月1日</th><th class=\"split-table-header\" data-v-f18829ae>1月2日</th></tr></thead><tbody class=\"split-table-body\" data-v-f18829ae><tr data-v-f18829ae><td data-v-f18829ae><div class=\"split-slot-chip\" data-v-f18829ae><span data-v-f18829ae>レジ</span><span data-v-f18829ae>20:00 ~ 23:59</span></div></td><td data-v-f18829ae><div class=\"split-slot-chip\" data-v-f18829ae><span data-v-f18829ae>レジ</span><span data-v-f18829ae>24:00 ~ 5:00</span></div></td></tr></tbody></table></div></span></div>", 1);
const _hoisted_41 = { class: "settings-input oplus-form-switch" };
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_43 = { class: "settings-item" };
const _hoisted_44 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "希望シフト", -1 /* HOISTED */));
const _hoisted_46 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, [
        /*#__PURE__*/ (0, vue_2.createTextVNode)(" スタッフの希望と変更したシフトの両方を見れる機能。 "),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "本機能をONにすると:"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "-「戻す」ボタンが非表示となります。"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "- シフトをロックされている場合、スタッフはシフト提出ページで提出したシフトのみ閲覧できます。")
    ])
], -1 /* HOISTED */));
const _hoisted_48 = { class: "settings-input oplus-form-switch" };
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_50 = { class: "settings-item" };
const _hoisted_51 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "業務", -1 /* HOISTED */));
const _hoisted_53 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "業務一覧を表示する。")
], -1 /* HOISTED */));
const _hoisted_55 = { class: "settings-input oplus-form-switch" };
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_57 = { class: "settings-item" };
const _hoisted_58 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "デフォルト", -1 /* HOISTED */));
const _hoisted_60 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "デフォルトで表示される全体のシフト表")
], -1 /* HOISTED */));
const _hoisted_62 = { class: "d-flex flex-wrap settings-input" };
const _hoisted_63 = { class: "oplus-form-radio" };
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "週", -1 /* HOISTED */));
const _hoisted_66 = { class: "oplus-form-radio" };
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "月", -1 /* HOISTED */));
const _hoisted_69 = {
    key: 3,
    class: "settings-item settings-item-wrap"
};
const _hoisted_70 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "スケジュール", -1 /* HOISTED */));
const _hoisted_72 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "会社のニーズに最適なスケジュール期間を定義する")
], -1 /* HOISTED */));
const _hoisted_74 = { class: "settings-input oplus-form-switch" };
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_76 = {
    key: 0,
    class: "overtime-start-time-sub d-flex flex-center"
};
const _hoisted_77 = { class: "oplus-form-radio oplus-form-radio-reverse" };
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "カスタム範囲を設定する", -1 /* HOISTED */));
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_80 = { class: "flex-centered flex-justify-between" };
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "スケジュールの長さ", -1 /* HOISTED */));
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("hr", null, null, -1 /* HOISTED */));
const _hoisted_83 = { class: "schedule-length-dropdown-middle" };
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("p", null, "シフトサイクルの開始日と期間を設定してください。", -1 /* HOISTED */));
const _hoisted_85 = { class: "schedule-length-dropdown-middle-input-container" };
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("label", { for: "schedule-length" }, "間隔", -1 /* HOISTED */));
const _hoisted_87 = ["value"];
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "input-postfix-text" }, "日", -1 /* HOISTED */));
const _hoisted_89 = { class: "schedule-length-dropdown-middle-input-container" };
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("label", { for: "schedule-start" }, "開始日", -1 /* HOISTED */));
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("hr", null, null, -1 /* HOISTED */));
const _hoisted_92 = { class: "oplus-form-radio" };
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "月", -1 /* HOISTED */));
const _hoisted_95 = { class: "settings-item" };
const _hoisted_96 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "別々の費用", -1 /* HOISTED */));
const _hoisted_98 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト管理で交通費と労務費が別々に表示される。")
], -1 /* HOISTED */));
const _hoisted_100 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_102 = { class: "settings-item" };
const _hoisted_103 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "メモ", -1 /* HOISTED */));
const _hoisted_105 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト管理でメモが表示される。")
], -1 /* HOISTED */));
const _hoisted_107 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_109 = { class: "settings-item" };
const _hoisted_110 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "日表示", -1 /* HOISTED */));
const _hoisted_112 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "カレンダーを日表示にした際に、出勤時間が早い人順に並べられる")
], -1 /* HOISTED */));
const _hoisted_114 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_116 = { class: "settings-item" };
const _hoisted_117 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "業務時間", -1 /* HOISTED */));
const _hoisted_119 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "業務管理で作成した業務の時間表記設定")
], -1 /* HOISTED */));
const _hoisted_121 = { class: "d-flex flex-wrap settings-input justify-content-end flex-column" };
const _hoisted_122 = { class: "oplus-form-radio" };
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "表示しない", -1 /* HOISTED */));
const _hoisted_125 = { class: "oplus-form-radio" };
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "変更されたら表示", -1 /* HOISTED */));
const _hoisted_128 = { class: "oplus-form-radio" };
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "常に表示", -1 /* HOISTED */));
const _hoisted_131 = { class: "settings-item" };
const _hoisted_132 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "労務指標", -1 /* HOISTED */));
const _hoisted_134 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "労務の数値をシフト表に表示させる")
], -1 /* HOISTED */));
const _hoisted_136 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_137 = { class: "oplus-form-checkbox" };
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "日数", -1 /* HOISTED */));
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_140 = { class: "oplus-form-checkbox" };
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "公休", -1 /* HOISTED */));
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_143 = { class: "oplus-form-checkbox" };
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "労働", -1 /* HOISTED */));
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_146 = { class: "oplus-form-checkbox" };
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "有休", -1 /* HOISTED */));
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_149 = { class: "settings-item" };
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "定休日")
], -1 /* HOISTED */));
const _hoisted_151 = { class: "d-flex flex-wrap justify-content-end settings-input" };
const _hoisted_152 = { class: "oplus-form-checkbox" };
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "日", -1 /* HOISTED */));
const _hoisted_154 = ["checked"];
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_156 = { class: "oplus-form-checkbox" };
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "月", -1 /* HOISTED */));
const _hoisted_158 = ["checked"];
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_160 = { class: "oplus-form-checkbox" };
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "火", -1 /* HOISTED */));
const _hoisted_162 = ["checked"];
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_164 = { class: "oplus-form-checkbox" };
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "水", -1 /* HOISTED */));
const _hoisted_166 = ["checked"];
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_168 = { class: "oplus-form-checkbox" };
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "木", -1 /* HOISTED */));
const _hoisted_170 = ["checked"];
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_172 = { class: "oplus-form-checkbox" };
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "金", -1 /* HOISTED */));
const _hoisted_174 = ["checked"];
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_176 = { class: "oplus-form-checkbox" };
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "土", -1 /* HOISTED */));
const _hoisted_178 = ["checked"];
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_180 = { class: "settings-item" };
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name text-wrap" }, [
        /*#__PURE__*/ (0, vue_2.createTextVNode)("ボタン"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
        /*#__PURE__*/ (0, vue_2.createTextVNode)("のテキスト")
    ])
], -1 /* HOISTED */));
const _hoisted_182 = { class: "settings-multi-input settings-input w-40" };
const _hoisted_183 = { class: "settings-multi-item" };
const _hoisted_184 = { class: "oplus-form-checkbox" };
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-success" }, "○", -1 /* HOISTED */));
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_187 = { class: "settings-multi-item" };
const _hoisted_188 = { class: "oplus-form-checkbox" };
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-close zmdi-hc-lg text-error" })
], -1 /* HOISTED */));
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_191 = { class: "settings-multi-item" };
const _hoisted_192 = { class: "oplus-form-checkbox" };
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-error" }, "有休", -1 /* HOISTED */));
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_195 = { class: "settings-multi-item" };
const _hoisted_196 = { class: "oplus-form-checkbox" };
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-error" }, "半有休", -1 /* HOISTED */));
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_199 = { class: "settings-multi-item" };
const _hoisted_200 = { class: "oplus-form-checkbox" };
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-error" }, "希望休", -1 /* HOISTED */));
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_203 = { class: "settings-item" };
const _hoisted_204 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name text-wrap" }, [
    /*#__PURE__*/ (0, vue_2.createTextVNode)("シフト提出"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
    /*#__PURE__*/ (0, vue_2.createTextVNode)("のボタン")
], -1 /* HOISTED */));
const _hoisted_206 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト提出のボタンを非表示設定")
], -1 /* HOISTED */));
const _hoisted_208 = { class: "settings-multi-input settings-input" };
const _hoisted_209 = { class: "settings-multi-item" };
const _hoisted_210 = { class: "oplus-form-checkbox" };
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-success" }, "○", -1 /* HOISTED */));
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_213 = { class: "settings-multi-item" };
const _hoisted_214 = { class: "oplus-form-checkbox" };
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-close zmdi-hc-lg text-error" })
], -1 /* HOISTED */));
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_217 = { class: "settings-multi-item" };
const _hoisted_218 = { class: "oplus-form-checkbox" };
const _hoisted_219 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-error" }, "有休", -1 /* HOISTED */));
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_221 = { class: "settings-multi-item" };
const _hoisted_222 = { class: "oplus-form-checkbox" };
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-error" }, "半有休", -1 /* HOISTED */));
const _hoisted_224 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_225 = { class: "settings-multi-item" };
const _hoisted_226 = { class: "oplus-form-checkbox" };
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-error" }, "法定休日", -1 /* HOISTED */));
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_229 = { class: "settings-multi-item" };
const _hoisted_230 = { class: "oplus-form-checkbox" };
const _hoisted_231 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-error" }, "法定外休日", -1 /* HOISTED */));
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_233 = { class: "settings-item" };
const _hoisted_234 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name text-wrap" }, [
    /*#__PURE__*/ (0, vue_2.createTextVNode)("シフト提出"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
    /*#__PURE__*/ (0, vue_2.createTextVNode)("の自由入力")
], -1 /* HOISTED */));
const _hoisted_236 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト提出の自由入力欄を非表示設定")
], -1 /* HOISTED */));
const _hoisted_238 = { class: "settings-multi-input settings-input" };
const _hoisted_239 = { class: "settings-multi-item" };
const _hoisted_240 = { class: "oplus-form-checkbox" };
const _hoisted_241 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "ラベル", -1 /* HOISTED */));
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_243 = { class: "settings-multi-item" };
const _hoisted_244 = { class: "oplus-form-checkbox" };
const _hoisted_245 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "から", -1 /* HOISTED */));
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_247 = { class: "settings-multi-item" };
const _hoisted_248 = { class: "oplus-form-checkbox" };
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "まで", -1 /* HOISTED */));
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_251 = { class: "settings-multi-item" };
const _hoisted_252 = { class: "oplus-form-checkbox" };
const _hoisted_253 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "メモ", -1 /* HOISTED */));
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_255 = { class: "settings-multi-item" };
const _hoisted_256 = { class: "oplus-form-checkbox" };
const _hoisted_257 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "休憩時間", -1 /* HOISTED */));
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_259 = { class: "settings-multi-item" };
const _hoisted_260 = { class: "oplus-form-checkbox" };
const _hoisted_261 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "コメント機能", -1 /* HOISTED */));
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_263 = { class: "settings-item" };
const _hoisted_264 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_265 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "業務を非表示", -1 /* HOISTED */));
const _hoisted_266 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト提出の業務を非表示")
], -1 /* HOISTED */));
const _hoisted_268 = { class: "settings-input oplus-form-switch" };
const _hoisted_269 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_270 = { class: "settings-item" };
const _hoisted_271 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_272 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "前通知", -1 /* HOISTED */));
const _hoisted_273 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_274 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "出勤前の事前確認通知")
], -1 /* HOISTED */));
const _hoisted_275 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_276 = { class: "settings-item" };
const _hoisted_277 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "週始め")
], -1 /* HOISTED */));
const _hoisted_278 = { class: "d-flex flex-wrap justify-content-end settings-input" };
const _hoisted_279 = { class: "oplus-form-radio" };
const _hoisted_280 = ["value"];
const _hoisted_281 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_282 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "日", -1 /* HOISTED */));
const _hoisted_283 = { class: "oplus-form-radio" };
const _hoisted_284 = ["value"];
const _hoisted_285 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_286 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "月", -1 /* HOISTED */));
const _hoisted_287 = { class: "oplus-form-radio" };
const _hoisted_288 = ["value"];
const _hoisted_289 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "火", -1 /* HOISTED */));
const _hoisted_291 = { class: "oplus-form-radio" };
const _hoisted_292 = ["value"];
const _hoisted_293 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_294 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "水", -1 /* HOISTED */));
const _hoisted_295 = { class: "oplus-form-radio" };
const _hoisted_296 = ["value"];
const _hoisted_297 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_298 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "木", -1 /* HOISTED */));
const _hoisted_299 = { class: "oplus-form-radio" };
const _hoisted_300 = ["value"];
const _hoisted_301 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_302 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "金", -1 /* HOISTED */));
const _hoisted_303 = { class: "oplus-form-radio" };
const _hoisted_304 = ["value"];
const _hoisted_305 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_306 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "土", -1 /* HOISTED */));
const _hoisted_307 = { class: "settings-item" };
const _hoisted_308 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "就業時間設定")
], -1 /* HOISTED */));
const _hoisted_309 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_310 = ["value"];
const _hoisted_311 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "時", -1 /* HOISTED */));
const _hoisted_312 = ["value"];
const _hoisted_313 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "時", -1 /* HOISTED */));
const _hoisted_314 = { class: "settings-item" };
const _hoisted_315 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "月始めの日")
], -1 /* HOISTED */));
const _hoisted_316 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_317 = ["value"];
const _hoisted_318 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "日", -1 /* HOISTED */));
const _hoisted_319 = { class: "settings-item" };
const _hoisted_320 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "年始めの月")
], -1 /* HOISTED */));
const _hoisted_321 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_322 = ["value"];
const _hoisted_323 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "月", -1 /* HOISTED */));
const _hoisted_324 = { class: "settings-item" };
const _hoisted_325 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_326 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "シフトの公休", -1 /* HOISTED */));
const _hoisted_327 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_328 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフが出した公休が「希望休」として表示される。")
], -1 /* HOISTED */));
const _hoisted_329 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_330 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_331 = { class: "settings-item" };
const _hoisted_332 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_333 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "業務の公休", -1 /* HOISTED */));
const _hoisted_334 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_335 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフが出した業務の公休が「希望休」として表示される。")
], -1 /* HOISTED */));
const _hoisted_336 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_337 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_338 = { class: "settings-item" };
const _hoisted_339 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_340 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "「○ x 有休」", -1 /* HOISTED */));
const _hoisted_341 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_342 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "「○」"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "「×」"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "「有休」"),
        /*#__PURE__*/ (0, vue_2.createTextVNode)("のボタンを非表示にする。 ")
    ])
], -1 /* HOISTED */));
const _hoisted_343 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_344 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_345 = { class: "settings-item" };
const _hoisted_346 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_347 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "スタッフロック", -1 /* HOISTED */));
const _hoisted_348 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_349 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "管理者が確定した日までのシフトは追加・編集が出来なくなる。")
], -1 /* HOISTED */));
const _hoisted_350 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_351 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_352 = { class: "settings-item" };
const _hoisted_353 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_354 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "確定されたシフト", -1 /* HOISTED */));
const _hoisted_355 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_356 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフが確定されたシフトしか見えない。シフト閲覧設定が必要。")
], -1 /* HOISTED */));
const _hoisted_357 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_358 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_359 = { class: "settings-item" };
const _hoisted_360 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_361 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "シフトをロック", -1 /* HOISTED */));
const _hoisted_362 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_363 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフのシフトをロック（以下の日にちからシフトを閲覧・提出出来なくする）")
], -1 /* HOISTED */));
const _hoisted_364 = { class: "d-flex flex-gap flex-wrap margin-left-auto" };
const _hoisted_365 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_366 = ["value"];
const _hoisted_367 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "年", -1 /* HOISTED */));
const _hoisted_368 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_369 = ["value"];
const _hoisted_370 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "月", -1 /* HOISTED */));
const _hoisted_371 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_372 = ["value"];
const _hoisted_373 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "日", -1 /* HOISTED */));
const _hoisted_374 = { class: "settings-item" };
const _hoisted_375 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_376 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "連勤アラート", -1 /* HOISTED */));
const _hoisted_377 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_378 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "連勤より多い場合アラート")
], -1 /* HOISTED */));
const _hoisted_379 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_380 = ["value"];
const _hoisted_381 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "日間", -1 /* HOISTED */));
const _hoisted_382 = { class: "settings-item" };
const _hoisted_383 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_384 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "連休アラート", -1 /* HOISTED */));
const _hoisted_385 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_386 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "連休より多い場合アラート")
], -1 /* HOISTED */));
const _hoisted_387 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_388 = ["value"];
const _hoisted_389 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "日間", -1 /* HOISTED */));
const _hoisted_390 = { class: "settings-item" };
const _hoisted_391 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_392 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "労務（週ごと）", -1 /* HOISTED */));
const _hoisted_393 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_394 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "週ごとの公休が最低日数に達していなければアラート ")
], -1 /* HOISTED */));
const _hoisted_395 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_396 = ["value"];
const _hoisted_397 = { class: "settings-item" };
const _hoisted_398 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_399 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "労務（月ごと）", -1 /* HOISTED */));
const _hoisted_400 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_401 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "月ごとの公休が最低日数に達していなければアラート ")
], -1 /* HOISTED */));
const _hoisted_402 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_403 = ["value"];
const _hoisted_404 = {
    key: 4,
    class: "settings-item"
};
const _hoisted_405 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_406 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "月最大出勤数", -1 /* HOISTED */));
const _hoisted_407 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_408 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "全スタッフの月間出勤日数の上限を設定する（基準20日、最大26日）")
], -1 /* HOISTED */));
const _hoisted_409 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_410 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-max-label" }, "MAX", -1 /* HOISTED */));
const _hoisted_411 = { class: "labor-day-input-group" };
const _hoisted_412 = ["value"];
const _hoisted_413 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "labor-day-suffix" }, "日", -1 /* HOISTED */));
const _hoisted_414 = {
    key: 5,
    class: "settings-item"
};
const _hoisted_415 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_416 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "月最大休日数", -1 /* HOISTED */));
const _hoisted_417 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_418 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, " 全スタッフの月間休日数の上限を設定する")
], -1 /* HOISTED */));
const _hoisted_419 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_420 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-max-label" }, "MAX", -1 /* HOISTED */));
const _hoisted_421 = { class: "labor-day-input-group" };
const _hoisted_422 = ["value"];
const _hoisted_423 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "labor-day-suffix" }, "日", -1 /* HOISTED */));
const _hoisted_424 = {
    key: 6,
    class: "settings-item"
};
const _hoisted_425 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_426 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "週最大出勤数", -1 /* HOISTED */));
const _hoisted_427 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_428 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "全スタッフの週間出勤日数の上限を設定する（基準5日、最大6日）")
], -1 /* HOISTED */));
const _hoisted_429 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_430 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-max-label" }, "MAX", -1 /* HOISTED */));
const _hoisted_431 = { class: "labor-day-input-group" };
const _hoisted_432 = ["value"];
const _hoisted_433 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "labor-day-suffix" }, "日", -1 /* HOISTED */));
const _hoisted_434 = {
    key: 7,
    class: "settings-item"
};
const _hoisted_435 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_436 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "週最大労務", -1 /* HOISTED */));
const _hoisted_437 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_438 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "全スタッフの週労働時間の上限を設定する（基準40時間、最大51時間25分）")
], -1 /* HOISTED */));
const _hoisted_439 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_440 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-max-label" }, "MAX", -1 /* HOISTED */));
const _hoisted_441 = {
    key: 8,
    class: "settings-item"
};
const _hoisted_442 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_443 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "月最大労務", -1 /* HOISTED */));
const _hoisted_444 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_445 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "全スタッフの月間労働時間の上限を設定する（基準：160時間，最大：205時間） ")
], -1 /* HOISTED */));
const _hoisted_446 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_447 = {
    key: 9,
    class: "settings-item settings-item-wrap"
};
const _hoisted_448 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_449 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "残業起算時間", -1 /* HOISTED */));
const _hoisted_450 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_451 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "設定した時間を超える勤務に対し、時給の1.25倍の割増賃金を適用する（基準：8時間）")
], -1 /* HOISTED */));
const _hoisted_452 = { class: "settings-input oplus-form-switch" };
const _hoisted_453 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_454 = {
    key: 0,
    class: "overtime-start-time-sub d-flex flex-center"
};
const _hoisted_455 = { class: "oplus-form-checkbox show-overtime-start-time-checkbox" };
const _hoisted_456 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "シフト管理で残業が表示される。", -1 /* HOISTED */));
const _hoisted_457 = ["value"];
const _hoisted_458 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "時間", -1 /* HOISTED */));
const _hoisted_459 = {
    key: 0,
    class: "settings-card-container accordion settings-accordion"
};
const _hoisted_460 = { class: "settings-title-wrapper accordion-header c-hand" };
const _hoisted_461 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right" }, null, -1 /* HOISTED */));
const _hoisted_462 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "計画管理", -1 /* HOISTED */));
const _hoisted_463 = { class: "accordion-body" };
const _hoisted_464 = { class: "settings-item" };
const _hoisted_465 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_466 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "メモ", -1 /* HOISTED */));
const _hoisted_467 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_468 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト表にメモを表示")
], -1 /* HOISTED */));
const _hoisted_469 = { class: "settings-input oplus-form-switch" };
const _hoisted_470 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_471 = { class: "settings-item" };
const _hoisted_472 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_473 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "売り上げ", -1 /* HOISTED */));
const _hoisted_474 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_475 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト表に売り上げを表示")
], -1 /* HOISTED */));
const _hoisted_476 = { class: "settings-input oplus-form-switch" };
const _hoisted_477 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_478 = { class: "settings-item" };
const _hoisted_479 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_480 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "利用人数", -1 /* HOISTED */));
const _hoisted_481 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_482 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト表に利用人数を表示")
], -1 /* HOISTED */));
const _hoisted_483 = { class: "settings-input oplus-form-switch" };
const _hoisted_484 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_485 = { class: "settings-item" };
const _hoisted_486 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_487 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "必要人数", -1 /* HOISTED */));
const _hoisted_488 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_489 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト表に必要人数を表示")
], -1 /* HOISTED */));
const _hoisted_490 = { class: "settings-input oplus-form-switch" };
const _hoisted_491 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_492 = { class: "settings-card-container accordion settings-accordion" };
const _hoisted_493 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("summary", { class: "settings-title-wrapper accordion-header c-hand" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right" }),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "page-title-text settings-accordion-icon" }, "その他")
], -1 /* HOISTED */));
const _hoisted_494 = { class: "accordion-body" };
const _hoisted_495 = { class: "settings-item" };
const _hoisted_496 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_497 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "サポート", -1 /* HOISTED */));
const _hoisted_498 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_499 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "サポートチャットを消す。 (ページを更新する必要があります)")
], -1 /* HOISTED */));
const _hoisted_500 = { class: "settings-input oplus-form-switch" };
const _hoisted_501 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_502 = { class: "settings-item" };
const _hoisted_503 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_504 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "揭示板", -1 /* HOISTED */));
const _hoisted_505 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_506 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフが掲示板を作成・コメント出来なくする。（閲覧のみ）")
], -1 /* HOISTED */));
const _hoisted_507 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_508 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_509 = { class: "settings-item" };
const _hoisted_510 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_511 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "自動作成最大連勤", -1 /* HOISTED */));
const _hoisted_512 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_513 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "自動シフト作成の際最大連勤を使う。")
], -1 /* HOISTED */));
const _hoisted_514 = {
    key: 0,
    class: "pro-label auto-label ml-2"
};
const _hoisted_515 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_516 = { class: "settings-item" };
const _hoisted_517 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_518 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "自動作成最大連休", -1 /* HOISTED */));
const _hoisted_519 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_520 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "自動シフト作成の際最大連休を使う。")
], -1 /* HOISTED */));
const _hoisted_521 = {
    key: 0,
    class: "pro-label auto-label ml-2"
};
const _hoisted_522 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_523 = { class: "settings-item" };
const _hoisted_524 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_525 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "インターバル", -1 /* HOISTED */));
const _hoisted_526 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_527 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "自動作成時に勤務間インターバルを考慮したシフトを組むことができる")
], -1 /* HOISTED */));
const _hoisted_528 = {
    key: 0,
    class: "pro-label auto-label ml-2"
};
const _hoisted_529 = { class: "settings-submit-button-wrapper" };
const vue_3 = require("vue");
const ShiftManagementIcon_vue_1 = __importDefault(require("../icons/ShiftManagementIcon.vue"));
const PlanManagementIcon_vue_1 = __importDefault(require("../icons/PlanManagementIcon.vue"));
const InfoIcon_vue_1 = __importDefault(require("../icons/InfoIcon.vue"));
const common_1 = require("../../common/common");
const dateInt_1 = __importDefault(require("../../common/dateInt"));
const settings_1 = require("../../js/settings");
const CalendarIcon_vue_1 = __importDefault(require("../icons/CalendarIcon.vue"));
const XIcon_vue_1 = __importDefault(require("../icons/XIcon.vue"));
const timeZones_1 = __importDefault(require("../../common/timeZones"));
const SCHEDULE_DROPDOWN_VIEWPORT_MARGIN = 8;
exports.default = (0, vue_1.defineComponent)({
    __name: 'SettingsShiftContent',
    props: {
        shiftSettings: {
            type: Object,
            required: true,
        },
        permissions: {
            type: Object,
            required: true,
        },
        branchCanEditSettings: {
            type: Boolean,
            default: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isUpdating: {
            type: Boolean,
            default: false,
        },
        isDefaultSettingsPage: {
            type: Boolean,
            default: false,
        },
        selectedOem: {
            type: Number,
            required: true,
        }
    },
    emits: ["emit-shift-settings", "emit-open-branch-max-labor-modal"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const { hasProPerm, hasAutoPerm, hasTrialPerm } = props.permissions;
        const disabledBtn = (0, vue_3.computed)(() => {
            return !hasTrialPerm && !hasProPerm ? 'disabled-btn' : '';
        });
        const disabledAuto = (0, vue_3.computed)(() => {
            return !hasAutoPerm ? 'disabled-btn' : '';
        });
        const localSettingShiftLockDate = (0, vue_3.ref)({
            shiftLockYear: 0,
            shiftLockMonth: 0,
            shiftLockDay: 0,
        });
        const localSettingsData = (0, vue_3.ref)({ ...props.shiftSettings });
        const scheduleLength = (0, vue_3.computed)({
            get: () => localSettingsData.value.scheduleLength ?? 0,
            set: (v) => { localSettingsData.value.scheduleLength = v; },
        });
        const scheduleDropdownOpen = (0, vue_3.ref)(false);
        const scheduleDropdownContainer = (0, vue_3.ref)(null);
        const scheduleDropdownEl = (0, vue_3.ref)(null);
        const scheduleDropdownStyle = (0, vue_3.ref)({});
        function updateScheduleDropdownPosition() {
            const container = scheduleDropdownContainer.value;
            const dropdown = scheduleDropdownEl.value;
            if (!container || !dropdown) {
                return;
            }
            const containerRect = container.getBoundingClientRect();
            const dropdownWidth = dropdown.getBoundingClientRect().width;
            const centeredLeft = containerRect.left + containerRect.width / 2 - dropdownWidth / 2;
            const minLeft = SCHEDULE_DROPDOWN_VIEWPORT_MARGIN;
            const maxLeft = window.innerWidth - dropdownWidth - SCHEDULE_DROPDOWN_VIEWPORT_MARGIN;
            const clampedLeft = Math.min(Math.max(centeredLeft, minLeft), maxLeft);
            scheduleDropdownStyle.value = {
                left: `${clampedLeft - containerRect.left}px`,
                transform: 'none',
            };
        }
        (0, vue_3.watch)(scheduleDropdownOpen, (isOpen) => {
            if (isOpen) {
                (0, vue_3.nextTick)(updateScheduleDropdownPosition);
                window.addEventListener('resize', updateScheduleDropdownPosition);
            }
            else {
                window.removeEventListener('resize', updateScheduleDropdownPosition);
            }
        });
        function handleScheduleDropdownBlur(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) {
                scheduleDropdownOpen.value = false;
            }
        }
        const scheduleStartDateInputEl = (0, vue_3.ref)(null);
        function openScheduleStartDatePicker() {
            const input = scheduleStartDateInputEl.value;
            if (!input) {
                return;
            }
            if (typeof input.showPicker === 'function') {
                input.showPicker();
            }
            else {
                input.focus();
            }
        }
        function handleScheduleDropdownClear() {
            localSettingsData.value.scheduleLength = 0;
            localSettingsData.value.scheduleStartDate = new Date(0);
        }
        function handleScheduleDropdownConfirm() {
            scheduleDropdownOpen.value = false;
            emit("emit-shift-settings", localSettingsData);
        }
        const shiftNotification = (0, vue_3.computed)({
            get: () => {
                return (0, common_1.durationToKitchenTime)(localSettingsData.value.shiftNotification, "minutes");
            },
            set: (value) => {
                localSettingsData.value.shiftNotification = (0, common_1.kitchenTimeToDuration)(value, "minutes");
            }
        });
        const shiftInterval = (0, vue_3.computed)({
            get: () => {
                return (0, common_1.durationToKitchenTime)(localSettingsData.value.shiftInterval, "minutes");
            },
            set: (value) => {
                localSettingsData.value.shiftInterval = (0, common_1.kitchenTimeToDuration)(value, "minutes");
            }
        });
        const scheduleStartDateInput = (0, vue_3.computed)({
            get: () => {
                const date = localSettingsData.value.scheduleStartDate;
                return date && date.getTime() !== 0 ? (0, common_1.yearMonthDateString)((0, common_1.fromOplusTime)(date), timeZones_1.default.ASIA_TOKYO) : "";
            },
            set: (value) => {
                localSettingsData.value.scheduleStartDate = value ? (0, common_1.toOplusTime)((0, common_1.dateFromString)(value, timeZones_1.default.ASIA_TOKYO)) : new Date(0);
            }
        });
        const loadingClass = (0, vue_3.computed)(() => {
            return {
                "loading": props.isUpdating,
            };
        });
        const disabledPage = (0, vue_3.computed)(() => {
            return {
                'disabled-page': !props.branchCanEditSettings,
            };
        });
        function handleMaxConsecutiveWorkdays(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.maxConsecutiveWorkdays = newVal;
        }
        function handleMaxConsecutiveDaysOff(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.maxConsecutiveDaysOff = newVal;
        }
        function handleStartOfMonthChange(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.monthStart = newVal;
        }
        function handleStartOfYearChange(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.yearStart = newVal;
        }
        function handleSummaryDayStartChange(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.summaryDayStart = newVal;
        }
        function handleSummaryDayEndChange(e) {
            let newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.summaryDayEnd = newVal;
        }
        function handleShiftLockYearChange(e) {
            let newVal = (0, settings_1.convertInputValToInt)(e);
            if (!newVal) {
                newVal = localSettingShiftLockDate.value.shiftLockYear;
            }
            localSettingShiftLockDate.value.shiftLockYear = newVal;
        }
        function handleShiftLockMonthChange(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingShiftLockDate.value.shiftLockMonth = newVal;
        }
        function handleShiftLockDayChange(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingShiftLockDate.value.shiftLockDay = newVal;
        }
        function splitShiftLockDate() {
            const shiftLockDate = localSettingsData.value.shiftLockDate;
            if (shiftLockDate) {
                localSettingShiftLockDate.value.shiftLockYear = shiftLockDate.getFullYear();
                localSettingShiftLockDate.value.shiftLockMonth = shiftLockDate.getMonth() + 1;
                localSettingShiftLockDate.value.shiftLockDay = shiftLockDate.getDate();
            }
            else {
                localSettingShiftLockDate.value.shiftLockYear = new Date().getFullYear();
                localSettingShiftLockDate.value.shiftLockMonth = null;
                localSettingShiftLockDate.value.shiftLockDay = null;
            }
        }
        function makeShiftLockDate() {
            const lockYear = localSettingShiftLockDate.value.shiftLockYear;
            const lockMonth = localSettingShiftLockDate.value.shiftLockMonth;
            const lockDay = localSettingShiftLockDate.value.shiftLockDay;
            if (lockYear && lockMonth && lockDay) {
                localSettingsData.value.shiftLockDate = new Date(lockYear, lockMonth - 1, lockDay);
            }
            else {
                localSettingsData.value.shiftLockDate = undefined;
            }
        }
        function handleOvertimeHoursInput(e) {
            localSettingsData.value.overtimeStartTimeHours = Number(e.target.value);
        }
        function handleCloseDaysChange(e, index) {
            const target = e.target;
            if (target && 'checked' in target) {
                localSettingsData.value.closedWeekdays[index] = target.checked;
                return;
            }
            return localSettingsData.value.closedWeekdays[index] = false;
        }
        const emit = __emit;
        function handleCalendarClick() {
            emit("emit-open-branch-max-labor-modal");
        }
        function handleShiftSubmit() {
            if (!props.branchCanEditSettings) {
                return;
            }
            makeShiftLockDate();
            if (localSettingsData.value.summaryDayStart >= localSettingsData.value.summaryDayEnd) {
                return (0, settings_1.importAlertModal)().alert("invalid time on 就業時間設定, start time should be less than the end time");
            }
            emit("emit-shift-settings", localSettingsData);
        }
        function onScheduleCustomIconClick() {
            if (localSettingsData.value.scheduleCustomEnabled) {
                scheduleDropdownOpen.value = !scheduleDropdownOpen.value;
            }
        }
        (0, vue_3.watch)(() => props.shiftSettings, (newSettings) => {
            localSettingsData.value = newSettings;
            splitShiftLockDate();
        }, { immediate: true }); // we want to fetch the initial data, and then re-fetch the data whenever relevant state changes.
        return (_ctx, _cache) => {
            return (__props.isLoading)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1))
                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                    key: 1,
                    ref: "settingsContainer",
                    class: (0, vue_2.normalizeClass)(["main-settings-container", disabledPage.value])
                }, [
                    (0, vue_2.createElementVNode)("details", _hoisted_2, [
                        (0, vue_2.createCommentVNode)(" Summary page settings "),
                        (0, vue_2.createElementVNode)("summary", _hoisted_3, [
                            _hoisted_4,
                            (0, vue_2.createVNode)(ShiftManagementIcon_vue_1.default, { class: "page-title-text settings-accordion-icon" }),
                            (0, vue_2.createElementVNode)("span", _hoisted_5, [
                                (0, vue_2.createTextVNode)(" シフト管理 "),
                                (__props.isDefaultSettingsPage)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_6, "（デフォルト設定）"))
                                    : (0, vue_2.createCommentVNode)("v-if", true)
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                            (0, vue_2.createCommentVNode)(" canView "),
                            (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                    _hoisted_10,
                                    (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_12
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_13, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((localSettingsData.value.staffCanViewSummary) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.staffCanViewSummary]
                                    ]),
                                    _hoisted_14
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" ProfilePhotoEnabled "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                        _hoisted_17,
                                        (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _hoisted_19
                                        ])
                                    ]),
                                    (!(0, vue_2.unref)(hasProPerm))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_20))
                                        : (0, vue_2.createCommentVNode)("v-if", true),
                                    (0, vue_2.createElementVNode)("label", {
                                        class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                    }, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((localSettingsData.value.profilePhotoEnabled) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.profilePhotoEnabled]
                                        ]),
                                        _hoisted_21
                                    ], 2 /* CLASS */)
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" ShowWageRelatedForNonOwners "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                        _hoisted_24,
                                        (0, vue_2.createElementVNode)("div", _hoisted_25, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _hoisted_26
                                        ])
                                    ]),
                                    (!(0, vue_2.unref)(hasProPerm))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_27))
                                        : (0, vue_2.createCommentVNode)("v-if", true),
                                    (0, vue_2.createElementVNode)("label", {
                                        class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                    }, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((localSettingsData.value.showWageRelatedForNonOwners) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.showWageRelatedForNonOwners]
                                        ]),
                                        _hoisted_28
                                    ], 2 /* CLASS */)
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" Confirm Shift Borders "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_29, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_30, [
                                        _hoisted_31,
                                        (0, vue_2.createElementVNode)("div", _hoisted_32, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _hoisted_33
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_34, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((localSettingsData.value.confirmShiftBorder) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.confirmShiftBorder]
                                        ]),
                                        _hoisted_35
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" splitNightShift "),
                            (0, vue_2.createElementVNode)("div", _hoisted_36, [
                                (0, vue_2.createElementVNode)("div", _hoisted_37, [
                                    _hoisted_38,
                                    (0, vue_2.createElementVNode)("div", _hoisted_39, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_40
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_41, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((localSettingsData.value.splitNightShift) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.splitNightShift]
                                    ]),
                                    _hoisted_42
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" stackedRequest "),
                            (0, vue_2.createElementVNode)("div", _hoisted_43, [
                                (0, vue_2.createElementVNode)("div", _hoisted_44, [
                                    _hoisted_45,
                                    (0, vue_2.createElementVNode)("div", _hoisted_46, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_47
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_48, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((localSettingsData.value.stackedRequest) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.stackedRequest]
                                    ]),
                                    _hoisted_49
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" showRoles "),
                            (0, vue_2.createElementVNode)("div", _hoisted_50, [
                                (0, vue_2.createElementVNode)("div", _hoisted_51, [
                                    _hoisted_52,
                                    (0, vue_2.createElementVNode)("div", _hoisted_53, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_54
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_55, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((localSettingsData.value.showRoles) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.showRoles]
                                    ]),
                                    _hoisted_56
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" defaultView "),
                            (0, vue_2.createElementVNode)("div", _hoisted_57, [
                                (0, vue_2.createElementVNode)("div", _hoisted_58, [
                                    _hoisted_59,
                                    (0, vue_2.createElementVNode)("div", _hoisted_60, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_61
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_62, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_63, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((localSettingsData.value.defaultView) = $event)),
                                            value: 0,
                                            type: "radio",
                                            name: "default-summary-view"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, localSettingsData.value.defaultView]
                                        ]),
                                        _hoisted_64,
                                        _hoisted_65
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_66, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((localSettingsData.value.defaultView) = $event)),
                                            value: 1,
                                            type: "radio",
                                            name: "default-summary-view"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, localSettingsData.value.defaultView]
                                        ]),
                                        _hoisted_67,
                                        _hoisted_68
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" operational phases "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_69, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_70, [
                                        _hoisted_71,
                                        (0, vue_2.createElementVNode)("div", _hoisted_72, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _hoisted_73
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_74, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((localSettingsData.value.scheduleEnabled) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.scheduleEnabled]
                                        ]),
                                        _hoisted_75
                                    ]),
                                    (localSettingsData.value.scheduleEnabled)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_76, [
                                            (0, vue_2.createElementVNode)("label", _hoisted_77, [
                                                _hoisted_78,
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((localSettingsData.value.scheduleCustomEnabled) = $event)),
                                                    value: true,
                                                    type: "radio",
                                                    name: "schedule-custom-radio",
                                                    onChange: _cache[11] || (_cache[11] = ($event) => (scheduleDropdownOpen.value = true))
                                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                    [vue_2.vModelRadio, localSettingsData.value.scheduleCustomEnabled]
                                                ]),
                                                _hoisted_79
                                            ]),
                                            (0, vue_2.createElementVNode)("div", {
                                                ref_key: "scheduleDropdownContainer",
                                                ref: scheduleDropdownContainer,
                                                class: "schedule-length-dropdown-container",
                                                tabindex: "0",
                                                onFocusout: handleScheduleDropdownBlur
                                            }, [
                                                (0, vue_2.createVNode)(CalendarIcon_vue_1.default, {
                                                    class: "c-hand calendar-icon",
                                                    onClick: onScheduleCustomIconClick
                                                }),
                                                (0, vue_2.createVNode)(vue_2.Transition, { name: "dropdown-shift" }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (scheduleDropdownOpen.value)
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                key: 0,
                                                                ref_key: "scheduleDropdownEl",
                                                                ref: scheduleDropdownEl,
                                                                class: "schedule-length-dropdown",
                                                                style: (0, vue_2.normalizeStyle)(scheduleDropdownStyle.value)
                                                            }, [
                                                                (0, vue_2.createElementVNode)("div", _hoisted_80, [
                                                                    _hoisted_81,
                                                                    (0, vue_2.createElementVNode)("div", {
                                                                        class: "schedule-length-dropdown-close",
                                                                        onClick: _cache[12] || (_cache[12] = ($event) => (scheduleDropdownOpen.value = false))
                                                                    }, [
                                                                        (0, vue_2.createVNode)(XIcon_vue_1.default)
                                                                    ])
                                                                ]),
                                                                _hoisted_82,
                                                                (0, vue_2.createElementVNode)("div", _hoisted_83, [
                                                                    _hoisted_84,
                                                                    (0, vue_2.createElementVNode)("div", _hoisted_85, [
                                                                        _hoisted_86,
                                                                        (0, vue_2.createElementVNode)("input", {
                                                                            value: scheduleLength.value || undefined,
                                                                            onInput: _cache[13] || (_cache[13] = ($event) => (scheduleLength.value = Number($event.target.value))),
                                                                            class: "form-input form-extra-small",
                                                                            placeholder: "0",
                                                                            name: "schedule-length"
                                                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_87),
                                                                        _hoisted_88
                                                                    ]),
                                                                    (0, vue_2.createElementVNode)("div", _hoisted_89, [
                                                                        _hoisted_90,
                                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                            ref_key: "scheduleStartDateInputEl",
                                                                            ref: scheduleStartDateInputEl,
                                                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((scheduleStartDateInput).value = $event)),
                                                                            class: "form-input form-extra-small",
                                                                            placeholder: "0",
                                                                            name: "schedule-start",
                                                                            type: "date"
                                                                        }, null, 512 /* NEED_PATCH */), [
                                                                            [vue_2.vModelText, scheduleStartDateInput.value]
                                                                        ]),
                                                                        (0, vue_2.createElementVNode)("span", {
                                                                            class: "input-postfix-text c-hand",
                                                                            onClick: openScheduleStartDatePicker
                                                                        }, [
                                                                            (0, vue_2.createVNode)(CalendarIcon_vue_1.default)
                                                                        ])
                                                                    ])
                                                                ]),
                                                                _hoisted_91,
                                                                (0, vue_2.createElementVNode)("div", { class: "flex-centered flex-justify-between" }, [
                                                                    (0, vue_2.createElementVNode)("button", {
                                                                        type: "button",
                                                                        class: "btn oplus-btn",
                                                                        onClick: handleScheduleDropdownClear
                                                                    }, "クリア"),
                                                                    (0, vue_2.createElementVNode)("button", {
                                                                        type: "button",
                                                                        class: "btn oplus-btn oplus-alt-btn",
                                                                        onClick: handleScheduleDropdownConfirm
                                                                    }, "確定")
                                                                ])
                                                            ], 4 /* STYLE */))
                                                            : (0, vue_2.createCommentVNode)("v-if", true)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ], 544 /* NEED_HYDRATION, NEED_PATCH */),
                                            (0, vue_2.createElementVNode)("label", _hoisted_92, [
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((localSettingsData.value.scheduleCustomEnabled) = $event)),
                                                    value: false,
                                                    type: "radio",
                                                    name: "schedule-custom-radio",
                                                    onChange: _cache[16] || (_cache[16] = ($event) => (scheduleDropdownOpen.value = false))
                                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                    [vue_2.vModelRadio, localSettingsData.value.scheduleCustomEnabled]
                                                ]),
                                                _hoisted_93,
                                                _hoisted_94
                                            ])
                                        ]))
                                        : (0, vue_2.createCommentVNode)("v-if", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" transportSummary "),
                            (0, vue_2.createElementVNode)("div", _hoisted_95, [
                                (0, vue_2.createElementVNode)("div", _hoisted_96, [
                                    _hoisted_97,
                                    (0, vue_2.createElementVNode)("div", _hoisted_98, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_99
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_100))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((localSettingsData.value.transportSummary) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.transportSummary]
                                    ]),
                                    _hoisted_101
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" memoSummary "),
                            (0, vue_2.createElementVNode)("div", _hoisted_102, [
                                (0, vue_2.createElementVNode)("div", _hoisted_103, [
                                    _hoisted_104,
                                    (0, vue_2.createElementVNode)("div", _hoisted_105, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_106
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_107))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((localSettingsData.value.memoSummary) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.memoSummary]
                                    ]),
                                    _hoisted_108
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" dwsSort "),
                            (0, vue_2.createElementVNode)("div", _hoisted_109, [
                                (0, vue_2.createElementVNode)("div", _hoisted_110, [
                                    _hoisted_111,
                                    (0, vue_2.createElementVNode)("div", _hoisted_112, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_113
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_114))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((localSettingsData.value.dwsSort) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.dwsSort]
                                    ]),
                                    _hoisted_115
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" showRoleTimes "),
                            (0, vue_2.createElementVNode)("div", _hoisted_116, [
                                (0, vue_2.createElementVNode)("div", _hoisted_117, [
                                    _hoisted_118,
                                    (0, vue_2.createElementVNode)("div", _hoisted_119, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_120
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_121, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_122, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((localSettingsData.value.showRoleTimes) = $event)),
                                            value: 0,
                                            type: "radio",
                                            name: "show-role-times"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, localSettingsData.value.showRoleTimes]
                                        ]),
                                        _hoisted_123,
                                        _hoisted_124
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_125, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((localSettingsData.value.showRoleTimes) = $event)),
                                            value: 1,
                                            type: "radio",
                                            name: "show-role-times"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, localSettingsData.value.showRoleTimes]
                                        ]),
                                        _hoisted_126,
                                        _hoisted_127
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_128, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((localSettingsData.value.showRoleTimes) = $event)),
                                            value: 2,
                                            type: "radio",
                                            name: "show-role-times"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, localSettingsData.value.showRoleTimes]
                                        ]),
                                        _hoisted_129,
                                        _hoisted_130
                                    ])
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_131, [
                                (0, vue_2.createElementVNode)("div", _hoisted_132, [
                                    _hoisted_133,
                                    (0, vue_2.createElementVNode)("div", _hoisted_134, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_135
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_136))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["d-flex flex-wrap justify-content-end settings-input", disabledBtn.value])
                                }, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_137, [
                                        (0, vue_2.createCommentVNode)(" isWorkCountInSummaryPage "),
                                        _hoisted_138,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((localSettingsData.value.isWorkCountInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isWorkCountInSummaryPage]
                                        ]),
                                        _hoisted_139
                                    ]),
                                    (0, vue_2.createCommentVNode)(" isVacationCountInSummaryPage "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_140, [
                                        _hoisted_141,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((localSettingsData.value.isVacationCountInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isVacationCountInSummaryPage]
                                        ]),
                                        _hoisted_142
                                    ]),
                                    (0, vue_2.createCommentVNode)(" isLaborInSummaryPage "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_143, [
                                        _hoisted_144,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((localSettingsData.value.isLaborInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isLaborInSummaryPage]
                                        ]),
                                        _hoisted_145
                                    ]),
                                    (0, vue_2.createCommentVNode)(" isPTOCountInSummaryPage "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_146, [
                                        _hoisted_147,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((localSettingsData.value.isPTOCountInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isPTOCountInSummaryPage]
                                        ]),
                                        _hoisted_148
                                    ])
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" closedWeekdays "),
                            (0, vue_2.createElementVNode)("div", _hoisted_149, [
                                _hoisted_150,
                                (0, vue_2.createElementVNode)("div", _hoisted_151, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_152, [
                                        _hoisted_153,
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[27] || (_cache[27] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).SUN))),
                                            checked: localSettingsData.value.closedWeekdays[0],
                                            name: "weekday-start",
                                            type: "checkbox"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_154),
                                        _hoisted_155
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_156, [
                                        _hoisted_157,
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[28] || (_cache[28] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).MON))),
                                            checked: localSettingsData.value.closedWeekdays[1],
                                            name: "weekday-start",
                                            type: "checkbox"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_158),
                                        _hoisted_159
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_160, [
                                        _hoisted_161,
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[29] || (_cache[29] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).TUE))),
                                            checked: localSettingsData.value.closedWeekdays[2],
                                            name: "weekday-start",
                                            type: "checkbox"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_162),
                                        _hoisted_163
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_164, [
                                        _hoisted_165,
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[30] || (_cache[30] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).WED))),
                                            checked: localSettingsData.value.closedWeekdays[3],
                                            name: "weekday-start",
                                            type: "checkbox"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_166),
                                        _hoisted_167
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_168, [
                                        _hoisted_169,
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[31] || (_cache[31] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).THUR))),
                                            checked: localSettingsData.value.closedWeekdays[4],
                                            name: "weekday-start",
                                            type: "checkbox"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_170),
                                        _hoisted_171
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_172, [
                                        _hoisted_173,
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[32] || (_cache[32] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).FRI))),
                                            checked: localSettingsData.value.closedWeekdays[5],
                                            name: "weekday-start",
                                            type: "checkbox"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_174),
                                        _hoisted_175
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_176, [
                                        _hoisted_177,
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[33] || (_cache[33] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).SAT))),
                                            checked: localSettingsData.value.closedWeekdays[6],
                                            name: "weekday-start",
                                            type: "checkbox"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_178),
                                        _hoisted_179
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Change Shift button in Modal "),
                            (0, vue_2.createElementVNode)("div", _hoisted_180, [
                                _hoisted_181,
                                (0, vue_2.createElementVNode)("div", _hoisted_182, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_183, [
                                        (0, vue_2.createCommentVNode)(" shiftWorkText "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_184, [
                                            _hoisted_185,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => ((localSettingsData.value.shiftWorkText) = $event)),
                                                class: "form-input form-small",
                                                type: "text"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelText, localSettingsData.value.shiftWorkText]
                                            ]),
                                            _hoisted_186
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_187, [
                                        (0, vue_2.createCommentVNode)(" shiftOffText "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_188, [
                                            _hoisted_189,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event) => ((localSettingsData.value.shiftOffText) = $event)),
                                                class: "form-input form-small",
                                                type: "text"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelText, localSettingsData.value.shiftOffText]
                                            ]),
                                            _hoisted_190
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_191, [
                                        (0, vue_2.createCommentVNode)(" shiftPTOText "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_192, [
                                            _hoisted_193,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => ((localSettingsData.value.shiftPTOText) = $event)),
                                                class: "form-input form-small",
                                                type: "text"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelText, localSettingsData.value.shiftPTOText]
                                            ]),
                                            _hoisted_194
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_195, [
                                        (0, vue_2.createCommentVNode)(" shiftHalfPTOText "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_196, [
                                            _hoisted_197,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event) => ((localSettingsData.value.shiftHalfPTOText) = $event)),
                                                class: "form-input form-small",
                                                type: "text"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelText, localSettingsData.value.shiftHalfPTOText]
                                            ]),
                                            _hoisted_198
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_199, [
                                        (0, vue_2.createCommentVNode)(" shiftStaffOffText "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_200, [
                                            _hoisted_201,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event) => ((localSettingsData.value.shiftStaffOffText) = $event)),
                                                class: "form-input form-small",
                                                type: "text"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelText, localSettingsData.value.shiftStaffOffText]
                                            ]),
                                            _hoisted_202
                                        ])
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Hide Shift button in Modal "),
                            (0, vue_2.createElementVNode)("div", _hoisted_203, [
                                (0, vue_2.createElementVNode)("div", _hoisted_204, [
                                    _hoisted_205,
                                    (0, vue_2.createElementVNode)("div", _hoisted_206, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_207
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_208, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_209, [
                                        (0, vue_2.createCommentVNode)(" IsHidingTypeOInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_210, [
                                            _hoisted_211,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event) => ((localSettingsData.value.isHidingTypeOInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypeOInShiftModal]
                                            ]),
                                            _hoisted_212
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_213, [
                                        (0, vue_2.createCommentVNode)(" IsHidingTypeXInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_214, [
                                            _hoisted_215,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event) => ((localSettingsData.value.isHidingTypeXInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypeXInShiftModal]
                                            ]),
                                            _hoisted_216
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_217, [
                                        (0, vue_2.createCommentVNode)(" IsHidingTypePTOInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_218, [
                                            _hoisted_219,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event) => ((localSettingsData.value.isHidingTypePTOInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypePTOInShiftModal]
                                            ]),
                                            _hoisted_220
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_221, [
                                        (0, vue_2.createCommentVNode)(" IsHidingTypeHalfPTOInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_222, [
                                            _hoisted_223,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event) => ((localSettingsData.value.isHidingTypeHalfPTOInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypeHalfPTOInShiftModal]
                                            ]),
                                            _hoisted_224
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_225, [
                                        (0, vue_2.createCommentVNode)(" IsHidingTypePublicHolidayInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_226, [
                                            _hoisted_227,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event) => ((localSettingsData.value.isHidingTypePublicHolidayInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypePublicHolidayInShiftModal]
                                            ]),
                                            _hoisted_228
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_229, [
                                        (0, vue_2.createCommentVNode)(" IsHidingTypeOtherHolidayInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_230, [
                                            _hoisted_231,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event) => ((localSettingsData.value.isHidingTypeOtherHolidayInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypeOtherHolidayInShiftModal]
                                            ]),
                                            _hoisted_232
                                        ])
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Hide Form Fields in Modal "),
                            (0, vue_2.createElementVNode)("div", _hoisted_233, [
                                (0, vue_2.createElementVNode)("div", _hoisted_234, [
                                    _hoisted_235,
                                    (0, vue_2.createElementVNode)("div", _hoisted_236, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_237
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_238, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_239, [
                                        (0, vue_2.createCommentVNode)(" isHidingPurposeInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_240, [
                                            _hoisted_241,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event) => ((localSettingsData.value.isHidingPurposeInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingPurposeInShiftModal]
                                            ]),
                                            _hoisted_242
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_243, [
                                        (0, vue_2.createCommentVNode)(" isHidingFromInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_244, [
                                            _hoisted_245,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event) => ((localSettingsData.value.isHidingFromInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingFromInShiftModal]
                                            ]),
                                            _hoisted_246
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_247, [
                                        (0, vue_2.createCommentVNode)(" isHidingToInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_248, [
                                            _hoisted_249,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event) => ((localSettingsData.value.isHidingToInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingToInShiftModal]
                                            ]),
                                            _hoisted_250
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_251, [
                                        (0, vue_2.createCommentVNode)(" isHidingMemoInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_252, [
                                            _hoisted_253,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event) => ((localSettingsData.value.isHidingMemoInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingMemoInShiftModal]
                                            ]),
                                            _hoisted_254
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_255, [
                                        (0, vue_2.createCommentVNode)(" isHidingRestInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_256, [
                                            _hoisted_257,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event) => ((localSettingsData.value.isHidingRestInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingRestInShiftModal]
                                            ]),
                                            _hoisted_258
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_259, [
                                        (0, vue_2.createCommentVNode)(" isHidingCommentInputInShiftModal "),
                                        (0, vue_2.createElementVNode)("label", _hoisted_260, [
                                            _hoisted_261,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event) => ((localSettingsData.value.isHidingCommentInputInShiftModal) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.isHidingCommentInputInShiftModal]
                                            ]),
                                            _hoisted_262
                                        ])
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" IsHidingRoleInStaffModal "),
                            (0, vue_2.createElementVNode)("div", _hoisted_263, [
                                (0, vue_2.createElementVNode)("div", _hoisted_264, [
                                    _hoisted_265,
                                    (0, vue_2.createElementVNode)("div", _hoisted_266, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_267
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_268, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event) => ((localSettingsData.value.isHidingRoleInStaffModal) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.isHidingRoleInStaffModal]
                                    ]),
                                    _hoisted_269
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" shiftNotification "),
                            (0, vue_2.createElementVNode)("div", _hoisted_270, [
                                (0, vue_2.createElementVNode)("div", _hoisted_271, [
                                    _hoisted_272,
                                    (0, vue_2.createElementVNode)("div", _hoisted_273, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_274
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_275))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["form-label settings-input", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event) => ((shiftNotification).value = $event)),
                                        class: "form-input oplus-input-time",
                                        type: "time"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelText, shiftNotification.value]
                                    ])
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" startOfWeek "),
                            (0, vue_2.createElementVNode)("div", _hoisted_276, [
                                _hoisted_277,
                                (0, vue_2.createElementVNode)("div", _hoisted_278, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_279, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                            value: (0, vue_2.unref)(dateInt_1.default).SUN,
                                            type: "radio",
                                            name: "default-start-weekday"
                                        }, null, 8 /* PROPS */, _hoisted_280), [
                                            [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                        ]),
                                        _hoisted_281,
                                        _hoisted_282
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_283, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                            value: (0, vue_2.unref)(dateInt_1.default).MON,
                                            type: "radio",
                                            name: "default-start-weekday"
                                        }, null, 8 /* PROPS */, _hoisted_284), [
                                            [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                        ]),
                                        _hoisted_285,
                                        _hoisted_286
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_287, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                            value: (0, vue_2.unref)(dateInt_1.default).TUE,
                                            type: "radio",
                                            name: "default-start-weekday"
                                        }, null, 8 /* PROPS */, _hoisted_288), [
                                            [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                        ]),
                                        _hoisted_289,
                                        _hoisted_290
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_291, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                            value: (0, vue_2.unref)(dateInt_1.default).WED,
                                            type: "radio",
                                            name: "default-start-weekday"
                                        }, null, 8 /* PROPS */, _hoisted_292), [
                                            [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                        ]),
                                        _hoisted_293,
                                        _hoisted_294
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_295, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                            value: (0, vue_2.unref)(dateInt_1.default).THUR,
                                            type: "radio",
                                            name: "default-start-weekday"
                                        }, null, 8 /* PROPS */, _hoisted_296), [
                                            [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                        ]),
                                        _hoisted_297,
                                        _hoisted_298
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_299, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                            value: (0, vue_2.unref)(dateInt_1.default).FRI,
                                            type: "radio",
                                            name: "default-start-weekday"
                                        }, null, 8 /* PROPS */, _hoisted_300), [
                                            [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                        ]),
                                        _hoisted_301,
                                        _hoisted_302
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_303, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                            value: (0, vue_2.unref)(dateInt_1.default).SAT,
                                            type: "radio",
                                            name: "default-start-weekday"
                                        }, null, 8 /* PROPS */, _hoisted_304), [
                                            [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                        ]),
                                        _hoisted_305,
                                        _hoisted_306
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Summary Day Start * End "),
                            (0, vue_2.createElementVNode)("div", _hoisted_307, [
                                _hoisted_308,
                                (0, vue_2.createElementVNode)("label", _hoisted_309, [
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleSummaryDayStartChange,
                                        value: localSettingsData.value.summaryDayStart,
                                        class: "form-input form-extra-small",
                                        type: "text",
                                        placeholder: "1"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_310),
                                    _hoisted_311,
                                    (0, vue_2.createTextVNode)(" 〜 "),
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleSummaryDayEndChange,
                                        value: localSettingsData.value.summaryDayEnd,
                                        class: "form-input form-extra-small",
                                        type: "text",
                                        placeholder: "24"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_312),
                                    _hoisted_313
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" startOfMonth "),
                            (0, vue_2.createElementVNode)("div", _hoisted_314, [
                                _hoisted_315,
                                (0, vue_2.createElementVNode)("label", _hoisted_316, [
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleStartOfMonthChange,
                                        value: localSettingsData.value.monthStart,
                                        class: "form-input form-small",
                                        type: "text",
                                        placeholder: "1"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_317),
                                    _hoisted_318
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" startOfYear "),
                            (0, vue_2.createElementVNode)("div", _hoisted_319, [
                                _hoisted_320,
                                (0, vue_2.createElementVNode)("label", _hoisted_321, [
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleStartOfYearChange,
                                        value: localSettingsData.value.yearStart,
                                        class: "form-input form-small",
                                        type: "text",
                                        placeholder: "12"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_322),
                                    _hoisted_323
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" requestOff "),
                            (0, vue_2.createElementVNode)("div", _hoisted_324, [
                                (0, vue_2.createElementVNode)("div", _hoisted_325, [
                                    _hoisted_326,
                                    (0, vue_2.createElementVNode)("div", _hoisted_327, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_328
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_329))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event) => ((localSettingsData.value.requestOff) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.requestOff]
                                    ]),
                                    _hoisted_330
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" roleRequestOff "),
                            (0, vue_2.createElementVNode)("div", _hoisted_331, [
                                (0, vue_2.createElementVNode)("div", _hoisted_332, [
                                    _hoisted_333,
                                    (0, vue_2.createElementVNode)("div", _hoisted_334, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_335
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_336))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event) => ((localSettingsData.value.roleRequestOff) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.roleRequestOff]
                                    ]),
                                    _hoisted_337
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" hideTimeLess "),
                            (0, vue_2.createElementVNode)("div", _hoisted_338, [
                                (0, vue_2.createElementVNode)("div", _hoisted_339, [
                                    _hoisted_340,
                                    (0, vue_2.createElementVNode)("div", _hoisted_341, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_342
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_343))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event) => ((localSettingsData.value.hideTimeLess) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.hideTimeLess]
                                    ]),
                                    _hoisted_344
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" staffLock "),
                            (0, vue_2.createElementVNode)("div", _hoisted_345, [
                                (0, vue_2.createElementVNode)("div", _hoisted_346, [
                                    _hoisted_347,
                                    (0, vue_2.createElementVNode)("div", _hoisted_348, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_349
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_350))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event) => ((localSettingsData.value.staffLock) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.staffLock]
                                    ]),
                                    _hoisted_351
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" staffLockedSummary "),
                            (0, vue_2.createElementVNode)("div", _hoisted_352, [
                                (0, vue_2.createElementVNode)("div", _hoisted_353, [
                                    _hoisted_354,
                                    (0, vue_2.createElementVNode)("div", _hoisted_355, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_356
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_357))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event) => ((localSettingsData.value.staffLockedSummary) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.staffLockedSummary]
                                    ]),
                                    _hoisted_358
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" shiftLockDate "),
                            (0, vue_2.createElementVNode)("div", _hoisted_359, [
                                (0, vue_2.createElementVNode)("div", _hoisted_360, [
                                    _hoisted_361,
                                    (0, vue_2.createElementVNode)("div", _hoisted_362, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_363
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_364, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_365, [
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: handleShiftLockYearChange,
                                            value: localSettingShiftLockDate.value.shiftLockYear,
                                            class: "form-input form-small",
                                            type: "text",
                                            placeholder: "2024"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_366),
                                        _hoisted_367
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_368, [
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: handleShiftLockMonthChange,
                                            value: localSettingShiftLockDate.value.shiftLockMonth,
                                            class: "form-input form-extra-small",
                                            type: "text",
                                            placeholder: "1"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_369),
                                        _hoisted_370
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_371, [
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: handleShiftLockDayChange,
                                            value: localSettingShiftLockDate.value.shiftLockDay,
                                            class: "form-input form-extra-small",
                                            type: "text",
                                            placeholder: "1"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_372),
                                        _hoisted_373
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" maxConsecutiveWorkdays "),
                            (0, vue_2.createElementVNode)("div", _hoisted_374, [
                                (0, vue_2.createElementVNode)("div", _hoisted_375, [
                                    _hoisted_376,
                                    (0, vue_2.createElementVNode)("div", _hoisted_377, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_378
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_379, [
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleMaxConsecutiveWorkdays,
                                        class: "form-input form-small",
                                        value: localSettingsData.value.maxConsecutiveWorkdays,
                                        type: "text",
                                        placeholder: "5"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_380),
                                    _hoisted_381
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" maxConsecutiveDaysOff "),
                            (0, vue_2.createElementVNode)("div", _hoisted_382, [
                                (0, vue_2.createElementVNode)("div", _hoisted_383, [
                                    _hoisted_384,
                                    (0, vue_2.createElementVNode)("div", _hoisted_385, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_386
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_387, [
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleMaxConsecutiveDaysOff,
                                        class: "form-input form-small",
                                        value: localSettingsData.value.maxConsecutiveDaysOff,
                                        type: "text",
                                        placeholder: "5"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_388),
                                    _hoisted_389
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" minVacationWeekly (labor) "),
                            (0, vue_2.createElementVNode)("div", _hoisted_390, [
                                (0, vue_2.createElementVNode)("div", _hoisted_391, [
                                    _hoisted_392,
                                    (0, vue_2.createElementVNode)("div", _hoisted_393, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_394
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_395, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                        "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event) => ((localSettingsData.value.minVacationWeekly) = $event)),
                                        class: "labor-select form-input form-select"
                                    }, [
                                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(7, (n) => {
                                            return (0, vue_2.createElementVNode)("option", {
                                                key: n - 1,
                                                value: n - 1
                                            }, (0, vue_2.toDisplayString)(n - 1), 9 /* TEXT, PROPS */, _hoisted_396);
                                        }), 64 /* STABLE_FRAGMENT */))
                                    ], 512 /* NEED_PATCH */), [
                                        [vue_2.vModelSelect, localSettingsData.value.minVacationWeekly]
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" minVacationMonthly (labor) "),
                            (0, vue_2.createElementVNode)("div", _hoisted_397, [
                                (0, vue_2.createElementVNode)("div", _hoisted_398, [
                                    _hoisted_399,
                                    (0, vue_2.createElementVNode)("div", _hoisted_400, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_401
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_402, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                        "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event) => ((localSettingsData.value.minVacationMonthly) = $event)),
                                        class: "labor-select form-input form-select"
                                    }, [
                                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(32, (n) => {
                                            return (0, vue_2.createElementVNode)("option", {
                                                key: n - 1,
                                                value: n - 1
                                            }, (0, vue_2.toDisplayString)(n - 1), 9 /* TEXT, PROPS */, _hoisted_403);
                                        }), 64 /* STABLE_FRAGMENT */))
                                    ], 512 /* NEED_PATCH */), [
                                        [vue_2.vModelSelect, localSettingsData.value.minVacationMonthly]
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" maxWorkDaysPerMonth "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_404, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_405, [
                                        _hoisted_406,
                                        (0, vue_2.createElementVNode)("div", _hoisted_407, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _hoisted_408
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_409, [
                                        _hoisted_410,
                                        (0, vue_2.createElementVNode)("div", _hoisted_411, [
                                            (0, vue_2.createElementVNode)("input", {
                                                value: localSettingsData.value.maxWorkDaysPerMonth,
                                                onInput: _cache[67] || (_cache[67] = ($event) => (localSettingsData.value.maxWorkDaysPerMonth = Number($event.target.value))),
                                                class: "form-input labor-day-input",
                                                type: "number",
                                                min: "0",
                                                max: "26",
                                                placeholder: "0"
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_412),
                                            _hoisted_413
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" maxVacationMonthly "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_414, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_415, [
                                        _hoisted_416,
                                        (0, vue_2.createElementVNode)("div", _hoisted_417, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _hoisted_418
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_419, [
                                        _hoisted_420,
                                        (0, vue_2.createElementVNode)("div", _hoisted_421, [
                                            (0, vue_2.createElementVNode)("input", {
                                                value: localSettingsData.value.maxVacationMonthly,
                                                onInput: _cache[68] || (_cache[68] = ($event) => (localSettingsData.value.maxVacationMonthly = Number($event.target.value))),
                                                class: "form-input labor-day-input",
                                                type: "number",
                                                min: "0",
                                                max: "31",
                                                placeholder: "0"
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_422),
                                            _hoisted_423
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" maxWorkDaysPerWeek "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_424, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_425, [
                                        _hoisted_426,
                                        (0, vue_2.createElementVNode)("div", _hoisted_427, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _hoisted_428
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_429, [
                                        _hoisted_430,
                                        (0, vue_2.createElementVNode)("div", _hoisted_431, [
                                            (0, vue_2.createElementVNode)("input", {
                                                value: localSettingsData.value.maxWorkDaysPerWeek,
                                                onInput: _cache[69] || (_cache[69] = ($event) => (localSettingsData.value.maxWorkDaysPerWeek = Number($event.target.value))),
                                                class: "form-input labor-day-input",
                                                type: "number",
                                                min: "0",
                                                max: "6",
                                                placeholder: "0"
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_432),
                                            _hoisted_433
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" maxWeekLaborMinutes "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_434, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_435, [
                                        _hoisted_436,
                                        (0, vue_2.createElementVNode)("div", _hoisted_437, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _hoisted_438
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_439, [
                                        _hoisted_440,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event) => ((localSettingsData.value.maxWeekLaborMinutes) = $event)),
                                            class: "form-input form-small",
                                            type: "text",
                                            placeholder: "HH:MM"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelText, localSettingsData.value.maxWeekLaborMinutes]
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" maxMonthLaborMinutes "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_441, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_442, [
                                        _hoisted_443,
                                        (0, vue_2.createElementVNode)("div", _hoisted_444, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _hoisted_445
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_446, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event) => ((localSettingsData.value.maxMonthLaborMinutes) = $event)),
                                            id: "max-month-labor-minutes",
                                            class: "max-month-labor-minutes form-input br-5",
                                            type: "text",
                                            placeholder: "HH:MM"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelText, localSettingsData.value.maxMonthLaborMinutes]
                                        ]),
                                        (0, vue_2.createElementVNode)("i", {
                                            class: "zmdi zmdi-calendar-note c-hand",
                                            onClick: handleCalendarClick
                                        })
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" overtimeStartTime "),
                            (__props.isDefaultSettingsPage)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_447, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_448, [
                                        _hoisted_449,
                                        (0, vue_2.createElementVNode)("div", _hoisted_450, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _hoisted_451
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_452, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event) => ((localSettingsData.value.overtimeStartTime) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.overtimeStartTime]
                                        ]),
                                        _hoisted_453
                                    ]),
                                    (localSettingsData.value.overtimeStartTime)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_454, [
                                            (0, vue_2.createElementVNode)("label", _hoisted_455, [
                                                _hoisted_456,
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                    "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event) => ((localSettingsData.value.showOvertimeStartTime) = $event)),
                                                    type: "checkbox",
                                                    class: "overtime-start-time-checkbox"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [vue_2.vModelCheckbox, localSettingsData.value.showOvertimeStartTime]
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("input", {
                                                value: localSettingsData.value.overtimeStartTimeHours,
                                                onInput: handleOvertimeHoursInput,
                                                type: "number",
                                                step: "any",
                                                class: "form-input form-small overtime-start-time-hours-input",
                                                min: "0.5",
                                                max: "24"
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_457),
                                            _hoisted_458
                                        ]))
                                        : (0, vue_2.createCommentVNode)("v-if", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ])
                    ]),
                    (0, vue_2.createCommentVNode)(" Plan page settings "),
                    ((0, vue_2.unref)(hasProPerm))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("details", _hoisted_459, [
                            (0, vue_2.createElementVNode)("summary", _hoisted_460, [
                                _hoisted_461,
                                (0, vue_2.createVNode)(PlanManagementIcon_vue_1.default, { class: "page-title-text settings-accordion-icon" }),
                                _hoisted_462
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_463, [
                                (0, vue_2.createCommentVNode)(" isPlanMemoInSummaryPage "),
                                (0, vue_2.createElementVNode)("div", _hoisted_464, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_465, [
                                        _hoisted_466,
                                        (0, vue_2.createElementVNode)("div", _hoisted_467, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _hoisted_468
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_469, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event) => ((localSettingsData.value.isPlanMemoInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isPlanMemoInSummaryPage]
                                        ]),
                                        _hoisted_470
                                    ])
                                ]),
                                (0, vue_2.createCommentVNode)(" isPlanRevenueInSummaryPage "),
                                (0, vue_2.createElementVNode)("div", _hoisted_471, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_472, [
                                        _hoisted_473,
                                        (0, vue_2.createElementVNode)("div", _hoisted_474, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _hoisted_475
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_476, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event) => ((localSettingsData.value.isPlanRevenueInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isPlanRevenueInSummaryPage]
                                        ]),
                                        _hoisted_477
                                    ])
                                ]),
                                (0, vue_2.createCommentVNode)(" isPlanNumEqInSummaryPage "),
                                (0, vue_2.createElementVNode)("div", _hoisted_478, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_479, [
                                        _hoisted_480,
                                        (0, vue_2.createElementVNode)("div", _hoisted_481, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _hoisted_482
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_483, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event) => ((localSettingsData.value.isPlanNumEqInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isPlanNumEqInSummaryPage]
                                        ]),
                                        _hoisted_484
                                    ])
                                ]),
                                (0, vue_2.createCommentVNode)(" isPlanNumInSummaryPage "),
                                (0, vue_2.createElementVNode)("div", _hoisted_485, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_486, [
                                        _hoisted_487,
                                        (0, vue_2.createElementVNode)("div", _hoisted_488, [
                                            (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                            _hoisted_489
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_490, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event) => ((localSettingsData.value.isPlanNumInSummaryPage) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isPlanNumInSummaryPage]
                                        ]),
                                        _hoisted_491
                                    ])
                                ])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createElementVNode)("details", _hoisted_492, [
                        _hoisted_493,
                        (0, vue_2.createElementVNode)("div", _hoisted_494, [
                            (0, vue_2.createCommentVNode)(" hideLiveChat "),
                            (0, vue_2.createElementVNode)("div", _hoisted_495, [
                                (0, vue_2.createElementVNode)("div", _hoisted_496, [
                                    _hoisted_497,
                                    (0, vue_2.createElementVNode)("div", _hoisted_498, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_499
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_500, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event) => ((localSettingsData.value.hideLiveChat) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.hideLiveChat]
                                    ]),
                                    _hoisted_501
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" staffNoBoard "),
                            (0, vue_2.createElementVNode)("div", _hoisted_502, [
                                (0, vue_2.createElementVNode)("div", _hoisted_503, [
                                    _hoisted_504,
                                    (0, vue_2.createElementVNode)("div", _hoisted_505, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_506
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_507))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event) => ((localSettingsData.value.staffNoBoard) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.staffNoBoard]
                                    ]),
                                    _hoisted_508
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" AutoConsec "),
                            (0, vue_2.createElementVNode)("div", _hoisted_509, [
                                (0, vue_2.createElementVNode)("div", _hoisted_510, [
                                    _hoisted_511,
                                    (0, vue_2.createElementVNode)("div", _hoisted_512, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_513
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasAutoPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_514))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledAuto.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event) => ((localSettingsData.value.autoConsec) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.autoConsec]
                                    ]),
                                    _hoisted_515
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" AutoConsecDaysOfff "),
                            (0, vue_2.createElementVNode)("div", _hoisted_516, [
                                (0, vue_2.createElementVNode)("div", _hoisted_517, [
                                    _hoisted_518,
                                    (0, vue_2.createElementVNode)("div", _hoisted_519, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_520
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasAutoPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_521))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledAuto.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event) => ((localSettingsData.value.autoConsecDaysOff) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.autoConsecDaysOff]
                                    ]),
                                    _hoisted_522
                                ], 2 /* CLASS */)
                            ]),
                            (0, vue_2.createCommentVNode)(" shiftInterval "),
                            (0, vue_2.createElementVNode)("div", _hoisted_523, [
                                (0, vue_2.createElementVNode)("div", _hoisted_524, [
                                    _hoisted_525,
                                    (0, vue_2.createElementVNode)("div", _hoisted_526, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_527
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasAutoPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_528))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["form-label settings-input", disabledAuto.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event) => ((shiftInterval).value = $event)),
                                        class: "form-input oplus-input-time",
                                        type: "time"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelText, shiftInterval.value]
                                    ])
                                ], 2 /* CLASS */)
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_529, [
                        (0, vue_2.createElementVNode)("button", {
                            class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn", loadingClass.value]),
                            onClick: handleShiftSubmit
                        }, "確定", 2 /* CLASS */)
                    ])
                ], 2 /* CLASS */));
        };
    }
});
